(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn17-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const renderEditorial = (root, variant) => {
    const configNode = root.querySelector('[data-sn21-story-copy]');
    if (!configNode || root.dataset.coverOnly === 'true') return;
    let config, map;
    try {
      config = JSON.parse(configNode.textContent);
      map = JSON.parse(root.querySelector('[data-sn17-media-map]').textContent);
    } catch { return; }
    const id = variant?.id || root.querySelector('[data-sn17-variant-id]')?.value || root.dataset.currentVariant;
    const photos = (map[String(id)] || []).filter(photo => photo.src && typeof photo.src === 'string');
    const story = root.querySelector('[data-sn17-product-story]');
    const views = root.querySelector('[data-sn17-story-views]');
    const grid = root.querySelector('[data-sn17-story-view-grid]');
    if (!story || !views || !grid) return;
    story.hidden = photos.length === 0;
    views.hidden = photos.length === 0;
    if (!photos.length) return;
    const copy = config.products[config.code] || ['Une forme à découvrir', 'Regardez la forme du produit avant de choisir.', 'Votre moment à vous', 'Découvrez les vues disponibles du produit.', 'Le contenu exact est indiqué sur la fiche.', 'Votre produit', ['Forme du produit', 'Coloris sélectionné', 'Contenu précisé sur la fiche']];
    const role = value => photos.find(photo => photo.role === value);
    const choice = variant || JSON.parse(root.querySelector('[data-sn17-variants]').textContent).find(item => String(item.id) === String(id));
    const studio = role('studio');
    const illustration = role('illustration');
    const otherStudio = photos.find(photo => photo.role === 'studio' && photo.src !== studio?.src);
    const otherIllustration = photos.find(photo => photo.role === 'illustration' && photo.src !== illustration?.src);
    const cards = [
      { photo: studio, title: copy[0], text: copy[1] },
      { photo: illustration || role('usage'), title: copy[2], text: copy[3] },
      { photo: role('matiere'), title: config.colourTitle, text: `${config.colourPrefix} ${choice?.title || ''}. ${config.colourText}` },
      { photo: otherStudio || otherIllustration, title: config.includedTitle, text: copy[4], summary: copy[5] }
    ];
    const seen = new Set();
    grid.replaceChildren();
    const title = views.querySelector('h2');
    if (title) title.textContent = config.heading;
    cards.forEach(card => {
      const figure = document.createElement('figure');
      figure.className = 'sn17-story-view sn21-benefit';
      const photo = card.photo && !seen.has(card.photo.src) ? card.photo : null;
      if (photo) {
        seen.add(photo.src);
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.sn17StoryView = String(photos.indexOf(photo));
        button.setAttribute('aria-label', `${config.view} — ${card.title}`);
        const image = document.createElement('img');
        image.src = photo.src;
        image.alt = photo.alt || '';
        image.width = photo.width || 1254;
        image.height = photo.height || 1254;
        image.loading = 'lazy';
        image.decoding = 'async';
        button.append(image);
        figure.append(button);
      } else {
        const panel = document.createElement('div');
        panel.className = 'sn21-benefit__summary';
        const summary = document.createElement('span');
        summary.textContent = card.summary || card.title;
        panel.append(summary);
        figure.append(panel);
      }
      const caption = document.createElement('figcaption');
      const heading = document.createElement('strong');
      heading.textContent = card.title;
      const text = document.createElement('span');
      text.className = 'sn21-benefit__text';
      text.textContent = card.text;
      caption.append(heading, text);
      figure.append(caption);
      grid.append(figure);
    });
    grid.style.setProperty('--sn17-view-columns', '4');
    const detail = root.querySelector('[data-sn21-product-detail]');
    const material = role('matiere');
    if (detail) {
      detail.hidden = !material;
      if (material) {
        const image = detail.querySelector('img');
        image.src = material.src;
        image.alt = material.alt || '';
        image.width = material.width || 1254;
        image.height = material.height || 1254;
      }
      const facts = detail.querySelector('[data-sn21-detail-facts]');
      facts.replaceChildren();
      copy[6].forEach(text => {
        const fact = document.createElement('li');
        fact.textContent = text;
        facts.append(fact);
      });
      const oldMaterial = root.querySelector('[data-sn17-story-material]');
      if (oldMaterial && material) oldMaterial.hidden = true;
    }
  };
  document.addEventListener('sn17:variant-change', event => {
    const root = event.target.closest('[data-sn17-product]');
    if (root) renderEditorial(root, event.detail?.variant);
  });
  const init = scope => scope.querySelectorAll('[data-sn17-product]').forEach(root => renderEditorial(root));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv10-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* A5 : « Gérer mes cookies ». Le bandeau de consentement de Shopify expose window.privacyBanner.showPreferences()
       quand il est actif ; le bouton reste masqué tant que ce n'est pas le cas (10 s au plus d'attente). */
    function ready() {
      return window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    }
    function init() {
      var items = document.querySelectorAll('[data-sv10-cookies]');
      if (!items.length) return;
      var tries = 0;
      (function check() {
        if (ready()) {
          items.forEach(function (li) {
            var btn = li.querySelector('button');
            if (btn && !btn.dataset.sv10Bound) {
              btn.dataset.sv10Bound = '1';
              btn.addEventListener('click', function () {
                window.privacyBanner.showPreferences();
              });
            }
            li.hidden = false;
          });
          return;
        }
        tries += 1;
        if (tries < 20) setTimeout(check, 500);
      })();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv10-heights"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.sv10HeightsReady) return;
    window.sv10HeightsReady = true;
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var button = target.closest('[data-sv10-edge]');
      if (!button) return;
      var root = button.closest('[data-sv10-heights]');
      if (!root) return;
      var edge = button.getAttribute('data-sv10-edge');
      var buttons = root.querySelectorAll('[data-sv10-edge]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', buttons[i] === button ? 'true' : 'false');
      }
      var figure = root.querySelector('[data-sv10-fig]');
      if (figure) figure.setAttribute('data-edge', edge);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv10-promises"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.sv10PromisesReady) return;
    window.sv10PromisesReady = true;
    /* La carte de l'onglet choisi passe en tête de rangée ; on ramène la rangée au début. */
    document.addEventListener('s10:tabchange', function (event) {
      var root = event.target && event.target.closest ? event.target.closest('.sv10-promises') : null;
      if (!root) return;
      var track = root.querySelector('[data-sv10-promises-track]');
      if (!track || track.scrollLeft === 0) return;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (track.scrollTo) track.scrollTo({ left: 0, behavior: still ? 'auto' : 'smooth' });
      else track.scrollLeft = 0;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv7-product"]) return;
  try {
    
(function () {
  /* v14 : la légende visible sous la grande image (data-sv16-caption) reprend le texte alternatif de l'image affichée.
     somnila-v7.js change la source et le texte alternatif de l'image (miniature, coloris) ; on observe ces deux attributs. */
  function captions() {
    document.querySelectorAll('.sv16-pdp').forEach(function (root) {
      if (root.dataset.sv16CaptionReady) return;
      var main = root.querySelector('[data-sv7-main]'), cap = root.querySelector('[data-sv16-caption]');
      if (!main || !cap || !window.MutationObserver) return;
      root.dataset.sv16CaptionReady = '1';
      new MutationObserver(function () { cap.textContent = main.getAttribute('alt') || ''; }).observe(main, { attributes: true, attributeFilter: ['alt', 'src'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', captions); else captions();
  document.addEventListener('shopify:section:load', captions);

  /* La première miniature suit le coloris (têtes de galerie de l'Oreiller Somnila). somnila-v7.js écoute chaque bouton radio
     et change déjà la grande image ; cet écouteur, posé sur le document, passe après lui et aligne la miniature de tête. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.name || input.name.indexOf('sv7-opt-') !== 0 || !input.closest) return;
    var root = input.closest('.sv10-pdp');
    var thumb = root && root.querySelector('[data-sv12-lead]');
    var main = root && root.querySelector('[data-sv7-main]');
    var data = root && root.querySelector('script[data-sv7-offers]');
    if (!thumb || !main || !data) return;
    var src = main.getAttribute('src'), known = false, offers;
    try { offers = JSON.parse(data.textContent); } catch (e) { return; }
    if (!offers || !offers[0] || !offers[0].variants) return;
    var th = '';
    offers[0].variants.forEach(function (v) { if (v.img && v.img === src) { known = true; th = v.th || ''; } });
    if (!known) return;
    thumb.setAttribute('data-src', src);
    thumb.setAttribute('data-alt', main.alt);
    thumb.setAttribute('aria-label', main.alt);
    /* Retouches de design (01/10) : la grande image est le calque « sur la ligne » ; la miniature et la barre collante
       prennent la tête carrée du même coloris (« th »), lisible en petit. */
    var small = thumb.querySelector('img');
    if (small) small.setAttribute('src', th || src);
    var stick = document.querySelector('[data-sv7-stick-img]');
    if (stick && th) stick.setAttribute('src', th);
    root.querySelectorAll('[data-sv7-thumb]').forEach(function (t) { t.setAttribute('aria-current', String(t === thumb)); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv9-search"]) return;
  try {
    
(function(){
  function init(){document.querySelectorAll('[data-sv9-search]:not([data-ready])').forEach(function(root){
    root.dataset.ready='true';var form=root.querySelector('form'),input=form.querySelector('input'),cards=Array.from(root.querySelectorAll('[data-sv9-search-item]')),count=root.querySelector('[data-sv9-result-count]'),empty=root.querySelector('[data-sv9-search-empty]'),pagesBox=root.querySelector('[data-sv9-search-pages]'),pages=Array.from(root.querySelectorAll('[data-sv9-search-page]'));
    function normalize(s){return s.normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().replace(/[^a-z0-9 ]/g,' ').split(/\s+/).filter(Boolean).map(function(word){return word.length>3?word.replace(/s$/,''):word;}).join(' ');}
    function filter(){var words=normalize(input.value).split(/\s+/).filter(Boolean),n=0;cards.forEach(function(card){var text=normalize(card.dataset.searchText),match=words.every(function(word){return text.indexOf(word)!==-1;});card.hidden=!match;if(match)n++;});count.textContent=n;empty.hidden=n!==0;var m=0;pages.forEach(function(item){var text=normalize(item.dataset.searchText),match=words.length>0&&words.every(function(word){return text.indexOf(word)!==-1;});item.hidden=!match;if(match)m++;});if(pagesBox)pagesBox.hidden=m===0;}
    input.addEventListener('input',filter);form.addEventListener('submit',function(e){e.preventDefault();filter();var url=new URL(window.location.href);if(input.value.trim())url.searchParams.set('q',input.value.trim());else url.searchParams.delete('q');history.replaceState({},'',url);});filter();
  });}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
